// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M11.7 5.53a1.506 1.506 0 0 0-.518.213c-.075.05-2.461 2.42-5.605 5.566C.237 16.653.1 16.792.048 16.932a.775.775 0 0 0 .022.572c.063.13.217.29.34.353a.832.832 0 0 0 .661.01c.065-.03 1.75-1.698 5.511-5.456L12 6.996l5.418 5.415c3.761 3.758 5.446 5.427 5.51 5.456.19.086.478.084.649-.003.175-.09.362-.308.39-.456.008-.044.024-.086.036-.094.011-.007.021-.079.021-.16 0-.08-.007-.139-.016-.13-.008.008-.04-.046-.071-.122-.052-.128-.418-.5-5.523-5.605-3.617-3.618-5.515-5.5-5.61-5.563-.29-.192-.77-.281-1.104-.204M.008 17.184c0 .086.004.12.01.078a.763.763 0 0 0 0-.156c-.006-.043-.01-.008-.01.078"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const ChevronTopIcon = Icon;
export default ChevronTopIcon;
